// extracted by mini-css-extract-plugin
module.exports = {"contentComponent":"AddressesList_contentComponent__uoL17","tableContainer":"AddressesList_tableContainer__KdsJP"};